var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{class:_vm.svgClass,style:({ width: _vm.size + 'px', height: _vm.size + 'px' }),attrs:{"aria-hidden":"true"}},[_c('use',{attrs:{"xlink:href":("/image/icons.svg#" + _vm.iconName),"fill":_vm.color}})])}
var staticRenderFns = []

export { render, staticRenderFns }